import React, { Fragment } from 'react';
import { isNumber } from '@finect/front-utils/isNumber';
import { currencyFormat } from '@finect/front-utils/currencyFormat';
import { Label } from './partials';
import { scale as scales, units } from './utils';
export var Number = function Number(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? 2 : _ref$decimals,
    _ref$scale = _ref.scale,
    scale = _ref$scale === void 0 ? 'one' : _ref$scale,
    _ref$bold = _ref.bold,
    bold = _ref$bold === void 0 ? false : _ref$bold,
    _ref$empty = _ref.empty,
    empty = _ref$empty === void 0 ? '—' : _ref$empty;
  var scaled = value / scales[scale];
  var unit = units[scale];
  return React.createElement(Label, {
    bold: bold
  }, isNumber(value) ? React.createElement(Fragment, null, React.createElement("span", null, currencyFormat(scaled, decimals)), React.createElement("span", null, unit)) : empty);
};